import { MenuItem } from "@blueprintjs/core"
import { useDebouncedValue } from "@mantine/hooks"
import StaticSelector from "components/Atoms/StaticSelector"
import { useSellableItemStockSelectorQuery } from "generated/graphql"
import React, { useState } from "react"
import { getAvailableStock } from "./OrderItem"

const StockSelector = ({
  orderItems,
  path,
  sellableItem,
  isConsolidated,
  distributionCentres,
}) => {
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebouncedValue(search, 500)

  const { data } = useSellableItemStockSelectorQuery({
    variables: {
      first: 10,
      query: debouncedSearch,
      filter: {
        // isLive: true,
        distributionCentres,
      },
    },
  })
  const items = data?.sellableItemStock || []
  return (
    <StaticSelector
      items={items}
      query={search}
      onQueryChange={setSearch}
      popoverClassName="vt-stock-selector-popover"
      searchVector={["sellableItem.name", "distributionCentre.name"]}
      itemRenderer={(item, { handleClick, modifiers }) => {
        const isPreviouslySelected = orderItems.some(
          oi => oi?.sellableItemStock?.id === item.id
        )
        const availableStock = getAvailableStock(item, isConsolidated)
        return (
          <MenuItem
            disabled={isPreviouslySelected || !availableStock}
            active={modifiers.active}
            key={item.id}
            onClick={handleClick}
            text={item?.sellableItem?.name}
            labelElement={availableStock}
          />
        )
      }}
      renderText={item =>
        item?.sellableItem?.name || sellableItem?.name || "Select"
      }
      path={`${path}.sellableItemStock`}
    />
  )
}

export default StockSelector
